"use strict";
/*
 * Lets the app mark scrolls it triggers itself (e.g. a "back to top" button,
 * scrollIntoView, restoring scroll position) so the scroll bot detector does not
 * mistake those jumps for inhuman scroll deltas.
 *
 * useScrollBehaviorBotCheck auto-marks window.scrollTo / window.scrollBy,
 * Element.scrollIntoView, and in-page anchor / hash-link jumps. For any other
 * way of moving the scroll (e.g. assigning scrollTop directly), call
 * markProgrammaticScroll() right before triggering it.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProgrammaticScrollActive = exports.markProgrammaticScroll = void 0;
// How long (in milliseconds) to keep ignoring scroll after a programmatic call.
// Long enough to cover the scroll settling, including smooth-scroll animation.
const PROGRAMMATIC_SCROLL_WINDOW_MS = 1000;
// Timestamp (ms since page load) until which scrolls are treated as
// app-triggered rather than user-driven.
let ignoreScrollUntilMs = 0;
const markProgrammaticScroll = () => {
    if (typeof performance === 'undefined') {
        return;
    }
    ignoreScrollUntilMs = performance.now() + PROGRAMMATIC_SCROLL_WINDOW_MS;
};
exports.markProgrammaticScroll = markProgrammaticScroll;
const isProgrammaticScrollActive = () => {
    if (typeof performance === 'undefined') {
        return false;
    }
    return performance.now() < ignoreScrollUntilMs;
};
exports.isProgrammaticScrollActive = isProgrammaticScrollActive;
